var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 23579",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 69",
    cx: 16,
    cy: 16,
    r: 16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16979",
    d: "M8.483 175.442a2.186 2.186 0 0 1-2.43 0L.1 171.471l-.1-.069v6.507a1.338 1.338 0 0 0 1.338 1.338H13.2a1.338 1.338 0 0 0 1.338-1.338V171.4a1.256 1.256 0 0 1-.1.069z",
    transform: "translate(8.696 -157.928)",
    style: {
      fill: "#1b74e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16980",
    d: "m.569 66.668 5.956 3.971a1.335 1.335 0 0 0 1.485 0l5.956-3.971a1.275 1.275 0 0 0 .569-1.064 1.339 1.339 0 0 0-1.335-1.338H1.338A1.339 1.339 0 0 0 0 65.6a1.275 1.275 0 0 0 .569 1.068z",
    transform: "translate(8.696 -53.834)",
    style: {
      fill: "#1b74e4"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.13b408323cad3d766dd862d71a946eae.svg";
export { ForwardRef as ReactComponent };